import { useIntl } from 'react-intl';
import { useQuery } from '@apollo/client';

import { CmsBanner, CmsBannerType } from '../../../../common/cms-banner';
import { ContentWrapper } from '../../../../common/content-wrapper';
import { useGetBanners } from '../../../../../hooks/use-get-banners';
import { useStyles } from './kids-banner.styles';
import { GET_DEPENDENTS } from '../../../../../graphql/profile/queries/get-dependents';
import { InternalLinks } from '../../../../../constants';
import { isAddDependentShow } from '../../../../../graphql/user/user.cache';

export const KidsBanner = (): JSX.Element | null => {
  const { data } = useQuery(GET_DEPENDENTS, { fetchPolicy: 'network-only' });
  const classes = useStyles();
  const intl = useIntl();

  const { url } = useGetBanners(CmsBannerType.kidsBanner);
  const link = data?.getDependents?.length ? `pwa:/${InternalLinks.forKids}` : `pwa:/${InternalLinks.aboutProfile}`;

  const handleClick = () => {
    if (link === `pwa:/${InternalLinks.aboutProfile}`) {
      isAddDependentShow(true);
    }
  };

  return (
    <section className={classes.root} aria-label={intl.formatMessage({ id: 'kidsPage.pageTitle' })}>
      <ContentWrapper>
        <CmsBanner
          url={url}
          pwaCallToActionLink={link}
          onClick={handleClick}
        />
      </ContentWrapper>
    </section>
  );
};
